<template>
  <section class="taskManagementPage">
    <GBreadcrumb bread="教材管理, 课程管理" />
    <SearchForm>
      <el-form ref="ref_searchForm" :inline="true" :model="searchForm" label-width="80px" @submit.native.prevent>
        <el-form-item label="" prop="name"><el-input v-model="searchForm.themeName" placeholder="请输入主题名称" /></el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchData">搜 索</el-button>
        </el-form-item>
      </el-form>
    </SearchForm>

    <TableContainer :title="currentTextBook.teachingName">
      <template slot="topContent">
        <ul class="tabHeader">
          <li v-for="(item, index) in tabsOptions" :key="index" :class="parseInt(activeTabsName) === item.id?'active':''" @click="tabClick(item.id)">
            <div class="img-box">
              <img :src="item.filePath">
              <p>{{ item.teachingName }}</p>
            </div>
            <SvgIcon icon-class="smile" size="34px" class="smile" />
          </li>
        </ul>
      </template>
      <template slot="button">
        <!-- <el-button type="primary" @click="updateTextbook">更新教材</el-button> -->
        <el-button type="success" @click="addTheme">添加主题</el-button>
      </template>
      <el-table :data="tableData" row-key="treeId" :tree-props="{children: 'children'}">
        <el-table-column prop="themeName" label="主题/课程类型" min-width="120" class-name="text_left">
          <template slot-scope="scope">
            <span v-if="scope.row.treeNode === 1">{{ scope.row.themeName }}</span>
            <span v-if="scope.row.treeNode !== 1">{{ scope.row.curriculumName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="organizationName" label="是否为试听课程" width="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.treeNode !== 1">{{ scope.row.isAudition === '1'?'是':'否' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="organizationName" label="打包状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.treeNode !== 1">
              <el-tag v-if="scope.row.isConf == 0" type="warning"> 未打包 </el-tag>
              <el-tag v-if="scope.row.isConf == 1" type="success"> 已打包 </el-tag>
              <el-tag v-if="scope.row.isConf == 2" type="info"> 打包中 </el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="100">
          <template slot-scope="scope">
            <el-button class="sortIcon" type="primary" round icon="el-icon-top" @click="sortUp(scope.row)" />
            <el-button class="sortIcon" type="primary" round icon="el-icon-bottom" @click="sortDown(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="330">
          <template slot-scope="scope">
            <el-button v-if="scope.row.treeNode === 1" type="text" class="textGreen" @click="editTheme(scope.row)">编辑主题</el-button>
            <el-button v-if="scope.row.treeNode === 1" type="text" class="textGreen" @click="settingSubjecClick(scope.row)">设置主题资料</el-button>
            <el-button v-if="scope.row.treeNode === 1" type="text" class="textGreen" @click="addCourseClick(scope.row)">添加课程</el-button>
            <el-button v-if="scope.row.treeNode === 1" type="text" class="textOrange" @click="deleteTheme(scope.row)">删除主题</el-button>
            <el-button v-if="scope.row.treeNode !== 1" type="text" class="textGreen" @click="editCourseClick(scope.row)">编辑课程</el-button>
            <el-button v-if="scope.row.treeNode !== 1" type="text" class="textOrange" @click="deleteCourse(scope.row)">删除课程</el-button>
          </template>
        </el-table-column>
      </el-table>
    </TableContainer>

    <GDialog :dialog.sync="themeDialog" @btnSure="submitThemeForm('ref_themeForm')" @btnClose="resetThemeForm('ref_themeForm')">
      <el-form ref="ref_themeForm" :model="themeForm" :rules="themeRules" label-width="100px" @submit.native.prevent>
        <el-form-item label="主题名称" prop="themeName">
          <el-input v-model="themeForm.themeName" maxlength="35" placeholder="请输入3-35个字符的主题名称" />
        </el-form-item>
        <!-- <el-form-item label="备注" prop="remark">
          <el-input v-model="themeForm.remark" maxlength="200" show-word-limit type="textarea" :autosize="{ minRows: 4, maxRows: 8}" placeholder="请输入备注" />
        </el-form-item> -->
      </el-form>
    </GDialog>

    <!-- 设置主题资料 -->
    <settingThemeData ref="ref_settingSubjec" :theme-row="currentThemeRow" :current-text-book="currentTextBook" />
    <!-- 添加课程 -->
    <addCourse ref="ref_addCourse" :material-id="Number(activeTabsName)" :row="currentThemeRow" :tabs-options="tabsOptions" @resetFetchData="fetchData" />
  </section>

</template>

<script>
import settingThemeData from './settingThemeData/settingThemeData.vue'
import addCourse from './addCourse/addCourse.vue'
import { getMaterialPageList, updateTeaching, selectTaskManageList, addTheme, updateTheme, deleteTheme, deleteCurriculum,
  moveUpTheme, moveDownTheme, moveUpCurriculum, moveDownCurriculum } from '@api/courseManagement/api_courseManagement'
export default {
  components: {
    settingThemeData,
    addCourse
  },
  data() {
    return {
      activeTabsName: '',
      currentThemeRow: {},
      tabsOptions: [],
      tabsOptionsUrl: [
        require('@/assets/images/L1A.jpg'),
        require('@/assets/images/L1B.jpg'),
        require('@/assets/images/L2A.jpg'),
        require('@/assets/images/L2B.jpg'),
        require('@/assets/images/L3A.jpg'),
        require('@/assets/images/L3B.jpg'),
        require('@/assets/images/L4A.jpg'),
        require('@/assets/images/L4B.jpg')
      ],
      themeDialog: {
        title: '标题哦',
        visible: false
      },
      searchForm: {
        themeName: ''
      },
      tableData: [],
      themeForm: {
        themeName: ''
      },
      themeRules: {
        themeName: [
          { required: true, message: '请输入主题名称', trigger: 'blur' },
          { min: 3, max: 35, message: '请输入3-35个字符的主题名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    currentTextBook () {
      let obj = {}
      for (const item of this.tabsOptions) {
        if (item.id === Number(this.activeTabsName)) {
          obj = item
          break
        }
      }
      return obj
    }
  },
  async created () {
    // this.getOptions()
    await this.getMaterialList()
    this.fetchData()
  },
  methods: {
    tabClick(id) {
      this.searchForm.themeName = ''
      this.activeTabsName = id.toString()
      this.fetchData()
    },

    getOptions () {
      this.getMaterialList()
    },

    // 获取教材列表
    getMaterialList() {
      return new Promise((resolve, reject) => {
        getMaterialPageList({ size: 0, page: 1 }).then(res => {
          this.tabsOptions = res.records
          this.activeTabsName = res.records[0].id.toString()
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },

    // 获取科目
    fetchData() {
      const params = {
        ...this.searchForm,
        materiaId: Number(this.activeTabsName)
      }
      selectTaskManageList(params).then(res => {
        if (res.length > 0) {
          this.tableData = res[0].children
        } else {
          this.tableData = []
        }
      })
    },

    // 更新教材
    updateTextbook () {
      updateTeaching({ teachingThemeId: Number(this.activeTabsName) }).then(res => {
        // this.tableData = res.[0].themeList
      })
    },
    // 添加主题
    addTheme () {
      this.themeDialog.visible = true
      this.themeDialog.title = '添加主题'
    },
    editTheme (row) {
      this.themeDialog.visible = true
      this.themeDialog.title = '编辑主题'
      this.themeForm.themeName = row.themeName
      this.currentThemeRow = row
    },
    deleteTheme (row) {
      this.$confirm('是否确认删除?', '提示', {
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        deleteTheme({ themeId: row.id }).then(res => {
          this.$message.success('删除成功')
          this.fetchData()
        })
      })
    },
    resetThemeForm(formName) {
      this.$refs[formName].resetFields()
      this.themeForm.themeName = ''
      this.themeDialog.visible = false
    },
    // 提交主题
    submitThemeForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) { return false }
        const params = {
          ...this.themeForm
        }
        let _api
        params.materialId = Number(this.activeTabsName)
        if (this.themeDialog.title === '添加主题') {
          _api = addTheme
        } else {
          if (this.currentThemeRow.themeName === params.themeName) {
            this.$message.error('主题名称未作修改！')
            return false
          }
          _api = updateTheme
          params.themeId = this.currentThemeRow.id
        }
        _api(params).then(res => {
          this.$message.success(this.themeDialog.title + '成功')
          this.resetThemeForm('ref_themeForm')
          this.fetchData()
          this.$refs.ref_addCourse.getOptions()
        })
      })
    },
    // 设置 主题资料 点击
    settingSubjecClick (row) {
      this.currentThemeRow = row
      this.$nextTick(() => {
        this.$refs.ref_settingSubjec.isShowsettingSubject = true
        this.$refs.ref_settingSubjec.fetchData()
      })
    },
    // 添加课程 点击
    addCourseClick (row) {
      this.currentThemeRow = row
      this.$store.commit('courseStep/SET_addOrEdit', 'add')
      this.$nextTick(() => {
        this.$refs.ref_addCourse.isShowAddCourse = true
        this.$refs.ref_addCourse.addCourseForm.themeIds = [row.id]
      })
    },
    // 编辑课程 点击
    editCourseClick (row) {
      this.currentThemeRow = row
      this.$store.commit('courseStep/SET_addOrEdit', 'edit')
      this.$nextTick(() => {
        this.$refs.ref_addCourse.isShowAddCourse = true
        this.$refs.ref_addCourse.getCourseDetail()
      })
    },
    deleteCourse (row) {
      this.$confirm('是否确认删除?', '提示', {
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        deleteCurriculum({ curriculumId: row.id }).then(res => {
          this.$message.success('删除成功')
          this.fetchData()
        })
      })
    },

    // 重置排序 向上
    sortUp (row) {
      let func = ''
      if (row.treeNode === 1) {
        func = moveUpTheme(row.id)
      } else {
        func = moveUpCurriculum(row.teachingThemeId, row.id)
      }
      func.then(res => {
        this.fetchData()
      })
    },
    // 重置排序 向下
    sortDown (row) {
      let func = ''
      if (row.treeNode === 1) {
        func = moveDownTheme(row.id)
      } else {
        func = moveDownCurriculum(row.teachingThemeId, row.id)
      }
      func.then(res => {
        this.fetchData()
      })
    }
  }
}
</script>

<style lang="scss">
  .taskManagementPage{
    .el-table .el-table__expand-icon .el-icon-arrow-right:before{
      content: "\e6d9";color: #8F8F8B;
    }
    .el-table__expand-icon--expanded{
      transform: rotate(0deg);
    }
    .el-table [class*=el-table__row--level] .el-table__expand-icon{
      border: 1px solid #EEEEEE;width: 20px;height: 20px;line-height: 19px;margin-right: 10px;
    }
    .el-table [class*=el-table__row--level] .el-table__expand-icon:hover{
      border-color: #ccc;cursor: pointer;
    }
    .el-table .el-table__expand-icon.el-table__expand-icon--expanded .el-icon-arrow-right:before{
      content: "\e6d8";color: #8F8F8B;
    }
    .sortIcon{
      padding: 6px;
      .el-icon-top,.el-icon-bottom{
        font-size: 14px;color: #53402B;
      }
    }

    .tabHeader{
      display: flex;padding-bottom:6px;border-bottom: 1px solid #EEEEEE;margin-bottom:10px;overflow-x: auto;
      li {
        text-align: center;margin-right:24px;cursor: pointer;
        &:last-child{margin-right: 0;}
        .img-box{
          border:3px solid white;border-radius: 12px;position: relative;
          img{width: 175px;height: 150px;border-radius: 12px;display: block;object-fit: cover;}
          p{position: absolute;left: 0;bottom: 0;right: 0;height: 32px;background: rgba(255, 255, 255, 0.8);
          color: #53402B;text-align: center;line-height: 32px;border-radius: 0 0 12px 12px;font-size: 14px;}
        }
        .smile{color: #FCDA6F;opacity: 0;margin-top:-5px;}
        &.active{
          div{border-color: #FCDA6F;}
          .smile{opacity: 1;}
        }
      }
    }

  //   .el-table__body .el-table__row td:first-child .cell{
  //     white-space: nowrap;
  //     overflow: hidden;
  //     text-overflow: ellipsis;
  //   }
  //   .el-table__body .el-table__row .el-button--success{
  //     box-shadow: none;
  //   }
  }
</style>
